export enum CourseType {
    Single,
    Master
}